import { isq } from "../../../isq/index.js";
import { DataSet } from "../../d3/legacy/sensor/dataset.js";
import { API } from "../../../api/api.js";
export const getSensorFeedProbeMap = async (sensorFeedType) => {
    const sensorFeedProbeIds = sensorFeedType.probes.map((probeDef) => probeDef.id);
    const sensorFeedProbeList = await API.getSensorProbes(sensorFeedProbeIds); //complete probe details of all probes found in feed
    console.log('sensorFeedProbeList', sensorFeedProbeList);
    //create probe map keyed on their id in same order as given by feed type definition
    return sensorFeedProbeIds
        .map((probeId) => {
        const feedTypeProbe = (sensorFeedType.probes.find((probe) => probe.id === probeId));
        const defaultProbeDefinition = (sensorFeedProbeList.find((probe) => probe.id === probeId));
        const probe = Object.assign(defaultProbeDefinition, feedTypeProbe);
        probe.isqUnit = isq.getUnit(probe.unit);
        // if (feedTypeProbe.unit) {
        //   //when the unit is defined here, we need to be able to convert to this unit
        //   Object.assign(probe, { isqUnit: isq.getUnit(probe.unit) });
        // }
        if (feedTypeProbe.thresholds) {
            //make threshold scale
            const monitoringThresholds = feedTypeProbe.thresholds
                .filter((thres) => isFinite(thres)) // && thres > 0.0)
                .sort();
            if (monitoringThresholds.length > 0) {
                probe.monitoringThreshold = monitoringThresholds.at(-1);
                // Object.assign(probe, {
                //   monitoringThreshold: monitoringThresholds.at(-1),
                // });
            }
        }
        return probe;
    })
        .reduce((map, probe) => {
        map[probe.id] = probe;
        return map;
    }, {});
};
export const getSelectedFeedIds = (selectedFeed, sensorFeedMap, feedName, feedId) => {
    if (sensorFeedMap) {
        let sensorFeeds = Object.values(sensorFeedMap);
        if (feedId) {
            sensorFeeds = sensorFeeds.filter((sensorFeed) => sensorFeed.id === feedId);
        }
        else if (feedName) {
            sensorFeeds = sensorFeeds.filter((sensorFeed) => sensorFeed.properties.name === feedName);
        }
        else if (selectedFeed !== "__all__") {
            sensorFeeds = sensorFeeds.filter((sensorFeed) => sensorFeed.id === selectedFeed);
        }
        return sensorFeeds.map((sensorFeed) => sensorFeed.id);
    }
    return [];
};
export const processSensorData = (feedPatterns, sensorData, sensorFeedProbes, feedSignalsMap) => {
    if (feedPatterns.length > 0 && sensorData) {
        Object.keys(sensorData.feedIdPatternMap).forEach((feedPattern) => {
            const feedIds = sensorData.feedIdPatternMap[feedPattern];
            if (feedIds && feedIds.length > 0) {
                const _feedId = feedIds[0];
                feedSignalsMap[_feedId] = getFeedSignals(_feedId, sensorData, sensorFeedProbes);
            }
        });
    }
};
const getFeedSignals = (feedId, sensorData, sensorFeedProbes) => {
    const feedProbeSignals = Object.keys(sensorData.feedIdProbeDataSetMap[feedId]).reduce((signals, feedProbeId) => {
        signals[feedProbeId] = sensorData.feedIdProbeDataSetMap[feedId][feedProbeId]
            .map((dataSetId) => getSignal(feedProbeId, dataSetId, sensorData, sensorFeedProbes))
            .filter((signal) => signal != undefined);
        return signals;
    }, {});
    return Object.keys(feedProbeSignals).reduce((feedSignals, probeId) => {
        if (feedProbeSignals[probeId] && feedProbeSignals[probeId].length > 0) {
            const main = feedProbeSignals[probeId][0].signal;
            const alternatives = feedProbeSignals[probeId]
                .map((probeSignal) => probeSignal.signal)
                .slice(1);
            main.setAlternatives(alternatives);
            feedSignals[probeId] = main;
            //   feedSignals[probeId] = {
            //     unitSymbol: feedProbeSignals[probeId][0].unitSymbol,
            //     main: feedProbeSignals[probeId][0].signal,
            //     alternatives: feedProbeSignals[probeId]
            //       .map((probeSignal) => probeSignal.signal)
            //       .slice(1),
            //   };
        }
        return feedSignals;
    }, {});
};
const getSignal = (feedProbeId, dataSetId, sensorData, sensorFeedProbes) => {
    const dataSetDef = sensorData.dataSets[dataSetId];
    if (dataSetDef && dataSetDef.data && dataSetDef.data.length > 0) {
        const dataSet = DataSet.get(dataSetDef);
        const probeIndex = dataSet.probeIndex(feedProbeId);
        if (probeIndex !== undefined) {
            const defaultProbeDefinition = sensorFeedProbes[feedProbeId];
            let targetUnit = defaultProbeDefinition.isqUnit;
            let unitSymbol = defaultProbeDefinition.isqUnit.getSymbol();
            const signal = dataSet.signal(probeIndex, targetUnit);
            return { signal, unitSymbol };
        }
    }
    return undefined;
};
export const legacyColorToColor = (color) => {
    if (typeof color === 'string') {
        return color;
    }
    else if (typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha === 'number' || typeof color.alpha === 'undefined')) {
        return { h: color.hue, s: color.saturation, l: color.lightness, opacity: color.alpha ?? 1 };
    }
    else {
        return color;
    }
};
